import Vue from 'vue'
import App from './page/app'
import router from './router'
import store from './vuex'
import './responsive'
import './assets/icon/loadAll.js'
import './index.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

import { post ,get } from './api'
Vue.prototype.$post = post
Vue.prototype.$get  = get

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
